export var FontUtil;
(function (FontUtil) {
    let WebFont;
    (function (WebFont) {
        let Url;
        (function (Url) {
            Url.NotoSansJP = 'https://fonts.googleapis.com/css?family=Noto+Sans+JP&display=swap';
        })(Url = WebFont.Url || (WebFont.Url = {}));
        function load(fontUrl) {
            const headElement = document.querySelector('head');
            if (headElement == null) {
                return;
            }
            const fontLinkElement = document.createElement('link');
            fontLinkElement.href = fontUrl;
            fontLinkElement.rel = 'stylesheet';
            headElement.append(fontLinkElement);
        }
        WebFont.load = load;
    })(WebFont = FontUtil.WebFont || (FontUtil.WebFont = {}));
})(FontUtil || (FontUtil = {}));
